import React, { useEffect, useState } from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaFacebookF, FaTwitter, FaLinkedinIn, FaGithub, FaInstagram } from "react-icons/fa";

const styles = {
  footer: {
    backgroundColor: "#111",
    color: "#fff",
    padding: "40px 0",
    fontFamily: "Arial, sans-serif",
  },
  container: {
    display: "flex",
    justifyContent: "space-around",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  section: {
    flex: 1,
    margin: "0 15px",
  },
  sectionHeader: {
    borderBottom: "2px solid #fff",
    paddingBottom: "10px",
    marginBottom: "15px",
  },
  list: {
    listStyle: "none",
    padding: 0,
  },
  listItem: {
    marginBottom: "10px",
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: "10px",
  },
  link: {
    color: "#fff",
    textDecoration: "none",
  },
  linkHover: {
    textDecoration: "underline",
  },
  bottom: {
    textAlign: "center",
    paddingTop: "20px",
    borderTop: "1px solid #444",
    marginTop: "20px",
  },
  bottomText: {
    color: "red",
  },
  socialIcons: {
    marginTop: "10px",
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    cursor: "pointer",
  },
};

const Footer = () => {
  const [footerData, setFooterData] = useState({
    websiteDescription: "",
    addressLine1: "",
    addressLine2: "",
    email: "",
    contactNo: "",
    socialLinks: {},
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch('http://localhost:5000/api/settings/'); // Replace with your actual API endpoint
        const data = await response.json();
        setFooterData({
          websiteDescription: data.websiteDescription,
          addressLine1: data.address,
          addressLine2: data.addressLine2,
          email: data.email,
          contactNo: data.contactNo,
          socialLinks: data.socialLinks,
        });
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchSettings();
  }, []);

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.section}>
          <h3 style={styles.sectionHeader}>ABOUT US</h3>
          <p>{footerData.websiteDescription}</p>
          <hr style={{ borderTop: "1px solid #ccc", margin: "20px 0" }} />
          <ul style={styles.list}>
            <li style={styles.listItem}><FaMapMarkerAlt style={styles.icon} /> {footerData.addressLine1} {footerData.addressLine2 && `, ${footerData.addressLine2}`}</li> 
            <li style={styles.listItem}><FaEnvelope style={styles.icon} /> {footerData.email}</li>
            <li style={styles.listItem}><FaPhone style={styles.icon} /> {footerData.contactNo}</li>
          </ul>
        </div>
        <div style={styles.section}>
          <h3 style={styles.sectionHeader}>USEFULL INFO LINKS</h3>
          <ul style={styles.list}>
            {["Gadgets", "Shop", "Term and Conditions", "Forums", "Top News of This Week", "Special Recipes", "Sign Up"].map((item) => (
              <li key={item}><a href="#" style={styles.link}>{item}</a></li>
            ))}
          </ul>
        </div>
        <div style={styles.section}>
          <h3 style={styles.sectionHeader}>ADVERTISEMENTS</h3>
          <ul style={styles.list}>
            {["Post an Add", "Adds Renew", "Price of Advertisements", "Adds Closed", "Monthly or Yearly", "Trial Adds", "Add Making"].map((item) => (
              <li key={item}><a href="#" style={styles.link}>{item}</a></li>
            ))}
          </ul>
        </div>
        <div style={styles.section}>
          <h3 style={styles.sectionHeader}>CAREER</h3>
          <ul style={styles.list}>
            {["Available Post", "Career Details", "How to Apply?", "Fre elance Job", "Be a Member", "Apply Now", "Send Your Resume"].map((item) => (
              <li key={item}><a href="#" style={styles.link}>{item}</a></li>
            ))}
          </ul>
        </div>
      </div>
      <hr style={{ borderTop: "1px solid #ccc", margin: "20px 0" }} />
      
      <div className="container p-4 pb-0">
        {/* Section: Social media */}
        <section className="mb-4 d-flex justify-content-center">
          {/* Facebook */}
          {footerData.socialLinks.facebook && (
            <a className="btn text-white btn-floating m-1" style={{ backgroundColor: "#3b5998", borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center" }} href={footerData.socialLinks.facebook} target="_blank" rel="noopener noreferrer" role="button">
              <FaFacebookF />
            </a>
          )}

          {/* Twitter */}
          {footerData.socialLinks.twitter && (
            <a className="btn text-white btn-floating m-1" style={{ backgroundColor: "#55acee", borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center" }} href={footerData.socialLinks.twitter} target="_blank" rel="noopener noreferrer" role="button">
              <FaTwitter />
            </a>
          )}

          {/* Instagram */}
          {footerData.socialLinks.instagram && (
            <a className="btn text-white btn-floating m-1" style={{ backgroundColor: "#ac2bac", borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center" }} href={footerData.socialLinks.instagram} target="_blank" rel="noopener noreferrer" role="button">
              <FaInstagram />
            </a>
          )}

          {/* Linkedin */}
          {footerData.socialLinks.linkedin && (
            <a className="btn text-white btn-floating m-1" style={{ backgroundColor: "#0082ca", borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center" }} href={footerData.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" role="button">
              <FaLinkedinIn />
            </a>
          )}

          {/* Github */}
          {footerData.socialLinks.github && (
            <a className="btn text-white btn-floating m-1" style={{ backgroundColor: "#333333", borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center" }} href={footerData.socialLinks.github} target="_blank" rel="noopener noreferrer" role="button">
              <FaGithub />
            </a>
          )}
        </section>
        {/* Section: Social media */}

        {/* Divider */}
     

      </div>
      {/* Grid container */}

      {/* Copyright */}
      <div className="text-center p-3" style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}>
        <p>© 2025 <span style={{ color: "red" }}>USNEWS</span>. All Rights Reserved.</p>
        <div>
          {["Home", "FAQ", "Support"].map((item) => (
            <a key={item} href="#" className="text-body">{item}</a>
          ))}
        </div>
      </div>
      <hr style={{ borderTop: "1px solid #ccc", margin: "20px 0" }} />
    </footer>
  );
};

export default Footer;